<template>
  <v-container
    fluid
    grid-list-xl
    mt--50
  >
    <core-refresh-informer
      :time="refreshTime"
      @refresh="refreshData"
    />
    <core-filter />

    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm5
        md4
        lg3
        xl2
      >
        <v-select
          v-model="selectedWorker"
          :label="$t('Common.programmer')"
          :items="workers"
          item-value="idx"
          item-text="name"
          clearable
          @click:clear="selectedWorker = undefined"
        />
      </v-flex>
    </v-layout>

    <!--Шапка раздела-->
    <v-card class="mobile-margin mt--20">
      <v-card-title class="pt-0 pb-1">
        <v-layout
          row
          wrap
        >
          <v-flex sm12>
            <v-text-field
              v-model="search"
              :label="$t('Common.search')"
              class="context-search "
              prepend-inner-icon="mdi-magnify"
              clearable
              single-line
              hide-details
            />
          </v-flex>
        </v-layout>
        <v-layout
          column
          align-end
        >
          <v-flex sm12>
            <v-btn
              v-if="isAdditionTaskAllowed"
              color="green darken-1"
              elevation="2"
              :small="screenWidth <= mobileMaxWidth"
              class="mr-2"
              @click="addTask(null)"
            >
              {{ $t('Common.add') }}
            </v-btn>
            <v-btn
              color="grey darken-1"
              elevation="2"
              :small="screenWidth <= mobileMaxWidth"
              @click="showBacklog"
            >
              {{ $t('Common.unassigned') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <!--Область данных-->
    <v-layout wrap>
      <template v-for="item in filteredData">
        <v-flex
          v-if="item.tasks.length > 0"
          :key="item.workerName"
          xs12
          class="pb-0"
        >
          <v-card class="mobile-margin">
            <v-card-title class="pa-0">
              <!--Шапка таблицы исполнителя-->
              <v-flex
                xs12
                text-xs-center
              >
                <h3>{{ item.workerName }}</h3>
                <p>{{ $t('Common.totalTime') }} {{ item.totalTime }} {{ $t('Common.hours') }}</p>
              </v-flex>
            </v-card-title>
            <!--Данные таблицы-->
            <v-data-table
              class="elevation-1 text-xs-center"
              :headers="workerTableHeaders"
              :items="item.tasks"
              hide-actions
              disable-initial-sort
            >
              <template v-slot:headers="props">
                <tr>
                  <template v-for="(header, headerIndex) in props.headers">
                    <th
                      v-if="typeof header.value === 'string'"
                      :key="headerIndex"
                      :class="'column text-xs-center ' + header.class"
                    >
                      {{ header.text }}
                    </th>
                  </template>
                </tr>
              </template>
              <template v-slot:items="rows">
                <tr @click="onRowClick(rows.item)">
                  <td
                    width="10%"
                    :class="statusColor(rows.item)"
                  >
                    {{ formatDate(rows.item['ДатаНачала']) }}
                  </td>
                  <td width="80%">
                    {{ rows.item['Описание'] }} (<span class="font-weight-medium font-italic">{{ rows.item['Автор'] }}</span>)
                  </td>
                  <td width="10%">
                    {{ rows.item['ВремяПлан'] }}
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                <div class="text-xs-center">
                  {{ noDataMsg }}
                </div>
              </template>
              <template v-slot:no-results>
                <span>{{ noDataMsg }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </template>
    </v-layout>

    <!--Всплывающее окно для добавления новой задачи-->
    <okil-add-task-window
      v-if="modalOpen"
      class="mobile-margin"
      :open="modalOpen"
      :workers="workers"
      :backlog="backlog"
      :variant="variant"
      :comment="comment"
      :screen-width="screenWidth"
      :screen-height="screenHeight"
      :mobile-max-width="mobileMaxWidth"
      @add-task="addTask"
      @assign-task="assignTask"
    />
  </v-container>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import { formatDate, isEmpty, sortTable, allowed } from '../utils/functions'
  export default {
    name: 'DevPlan',

    data () {
      return {
        mobileMaxWidth: 700,
        search: '',
        selectedWorker: undefined,
        modalOpen: false,
        variant: 1,
        comment: null,
        noDataMsg: this.$i18n.t('Common.noData'),
        workerTableHeaders: [
          {
            name: 'ДатаНачала',
            text: this.$i18n.t('Common.date'),
            value: 'ДатаНачала',
            sortable: true
          },
          {
            name: 'Описание',
            text: this.$i18n.t('Common.description'),
            value: 'Описание',
            sortable: false
          },
          {
            name: 'ВремяПлан',
            text: this.$i18n.t('Common.time'),
            value: 'ВремяПлан',
            sortable: true
          }
        ]
      }
    },

    computed: {
      ...mapState({
        data: state => state.devPlan.data,
        refreshTime: state => state.devPlan.refreshTime,
        backlog: state => state.devPlan.backlog,
        screenWidth: state => state.viewParam['screen-width'],
        screenHeight: state => state.viewParam['screen-height']
      }),

      ...mapGetters({
        isAuthenticated: 'auth/IS_AUTHENTICATED'
      }),

      isDataFetched () {
        return !isEmpty(this.data)
      },

      isAdditionTaskAllowed () {
        return allowed('scope', 'dev-plan-add-new-task')
      },

      workers () {
        return this.isDataFetched
          ? this.data.map((item, idx) => { return { idx, name: item.Заголовок } })
          : []
      },

      filteredData () {
        return this.isDataFetched
          ? this.data
            // фильтр по выбранному программисту
            .filter((_, idx) => ((this.selectedWorker === undefined) || (this.selectedWorker === idx)))
            .map(_item => {
              const tasks = _item.Таблица.filter(task => {
                if (isEmpty(this.search)) {
                  return true
                } else {
                  // фильтр по включению поисковой строки
                  const search = this.search.toLowerCase()
                  return (task.Описание.toLowerCase().indexOf(search) > -1) || (task.Автор.toLowerCase().indexOf(search) > -1)
                }
              })
              return {
                workerName: _item.Заголовок,
                totalTime: _item.Таблица.reduce((total, task) => (total + parseInt(task.ВремяПлан, 10)), 0),
                tasks: tasks
              }
            })
          : []
      }
    },

    mounted () {
      if (!this.isAuthenticated) {
        this.$router.push('/login')
      } else {
        if (!this.isDataFetched) {
          this.refreshData()
        }
      }
    },

    methods: {
      refreshData () {
        return this.$store.dispatch('devPlan/REQUEST_DATA')
      },

      statusColor (task) {
        let color = 'red'
        switch (task.Статус) {
          case 'В плане':
            color = 'blue lighten-2'
            break
          case 'В работе':
            color = 'green lighten-2'
            break
          case 'Создана':
            color = ''
            break
        }
        return color
      },

      translateHeader (h) {
        let result = {}
        for (let key in h) {
          result[key] = (key === 'text') ? this.$i18n.t(h[key]) : h[key]
        }
        return result
      },

      addTask (task = null) {
        this.modalOpen = !this.modalOpen
        this.variant = 1
        if (isEmpty(task)) { return }

        this.$store.dispatch('devPlan/ADD_TASK', task)
          .then(() => { this.refreshData() })
      },

      assignTask (task) {
        this.modalOpen = !this.modalOpen
        this.$store.dispatch('devPlan/ADD_TASK', task)
          .then(() => {
            this.refreshData()
            this.showBacklog()
          })
      },

      formatDate (v, format = 'DD.MM') {
        return formatDate(v, format)
      },

      sort (items, index, isDesc) {
        return sortTable(items, index, isDesc)
      },

      showBacklog () {
        this.variant = 2
        this.backLogList = []
        return this.$store.dispatch('devPlan/REQUEST_BACKLOG')
          .then(() => { this.modalOpen = !this.modalOpen })
      },

      onRowClick (row) {
        this.variant = 3
        this.comment = row['Комментарий']
        this.modalOpen = !this.modalOpen
      }
    }
  }
</script>
